import { render, staticRenderFns } from "./tab-details-create.html?vue&type=template&id=bf389792&scoped=true&"
import script from "./tab-details-create.js?vue&type=script&lang=js&"
export * from "./tab-details-create.js?vue&type=script&lang=js&"
import style0 from "./tab-details-create.scss?vue&type=style&index=0&id=bf389792&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf389792",
  null
  
)

export default component.exports